module.exports = "<button type=\"submit\" class=\"button\" [disabled]=\"disabled\">{{label}}</button>\n"